export const LOGIN_REQUEST='LOGIN_REQUEST'
export const LOGIN_FAIL='LOGIN_FAIL'
export const LOGIN_SUCCESS='LOGIN_SUCCESS'
export const SIGNUP_REQUEST='SIGNUP_REQUEST'
export const SIGNUP_SUCCESS='SIGNUP_SUCCESS'